<template>
  <AccordionCardInfoDisplay
    v-if="showForEntityTypes.includes(clickedEntityType)"
    :heading="title"
    :isExpanded="isExpanded"
    @onClicked="handleClick"
  >
    <template #content>
      <div v-if="!isLoadingSensordata && indoorData.length">
        <div v-for="(item, index) in indoorData" :key="index" class="indoor-data">
          <section v-if="item.value">{{ item.title }}</section>
          <section v-if="item.value">{{ item.value }}</section>
        </div>
      </div>
      <div v-else-if="isLoadingSensordata && !indoorData.length" class="no-data">
        <PulseLoader :loading="true" color="#3F46D6" />
      </div>
      <div v-else class="no-data">
        <p>{{ t('general__data__no-data-published') }}</p>
      </div>
    </template>
  </AccordionCardInfoDisplay>
</template>
<script lang="ts" setup>
import AccordionCardInfoDisplay from './AccordionCardInfoDisplay.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { computed, ref } from 'vue'
import { useSelectionStore } from '@/pinia/selection'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'

defineProps<{
  showForEntityTypes: string[]
  indoorData: indoorDataItem[]
}>()
type indoorDataItem = {
  title: string
  value: string
}
const { t } = useI18n()
const store = useStore()
const selectionStore = useSelectionStore()
const { clickedEntityType } = storeToRefs(selectionStore)
const title = t('general__text__indoor-data')
const isExpanded = ref(false)
const isLoadingSensordata = computed(() => store.state.planview.isLoadingSensordata)
function handleClick() {
  isExpanded.value = !isExpanded.value
}
</script>
<style lang="scss" scoped>
@use '@/design-system/design-tokens/font-mixins';
@use '@/design-system/design-tokens/variables.scss';
.indoor-data {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 4px;
}
section {
  @include font-mixins.desktop-regular-paragraph;
  color: variables.$color-greyscale-content;
}
.no-data {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  p {
    @include font-mixins.desktop-regular-label;
  }
}
</style>
